/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeRequestHourRangeRequest
 */
export interface ChangeRequestHourRangeRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestHourRangeRequest
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestHourRangeRequest
     */
    to?: string;
}

/**
 * Check if a given object implements the ChangeRequestHourRangeRequest interface.
 */
export function instanceOfChangeRequestHourRangeRequest(value: object): value is ChangeRequestHourRangeRequest {
    return true;
}

export function ChangeRequestHourRangeRequestFromJSON(json: any): ChangeRequestHourRangeRequest {
    return ChangeRequestHourRangeRequestFromJSONTyped(json, false);
}

export function ChangeRequestHourRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestHourRangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : json['from'],
        'to': json['to'] == null ? undefined : json['to'],
    };
}

export function ChangeRequestHourRangeRequestToJSON(json: any): ChangeRequestHourRangeRequest {
    return ChangeRequestHourRangeRequestToJSONTyped(json, false);
}

export function ChangeRequestHourRangeRequestToJSONTyped(value?: ChangeRequestHourRangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
        'to': value['to'],
    };
}

